import React from 'react';
import { flattenToAppURL } from '@plone/volto/helpers';
import { ImageListing } from 'iovisit-theme/components';

const SliderImage = (props) => {
  const { item, size, ...attrs } = props;

  if (item['@type'] === 'Artwork' && item.has_main_image) {
    return (
      <img
        src={flattenToAppURL(`${item['@id']}/@@images/main_image/${size}`)}
        alt={item?.['title']}
        loading="lazy"
        {...attrs}
      />
    );
  }
  return <ImageListing {...props} />;
};

export default SliderImage;
